import { computed } from 'vue';

export const buttonProps = {
    disabled: { type: Boolean, default: false },
    icon: { type: String, default: null },
    image: { type: String, default: null },
    link: { type: String, default: null },
    loading: { type: Boolean, default: false },
    roundedVariant: {
        type: String,
        default: 'md',
        validator: value => ['sm', 'md', 'pill'].includes(value),
    },
    target: { type: String, default: null },
    to: { type: [String, Object], default: null },
    type: { type: String, default: 'button' },
    variant: { type: String, default: 'secondary' },
    size: {
        type: String,
        default: 'md',
        validator: value => ['md', 'sm'].includes(value),
    },
};

export const useButton = (props) => {
    const tag = computed(() => {
        if (props.to) {
            return 'router-link';
        }
        if (props.link) {
            return 'a';
        }
        return 'button';
    });
    const currentBindings = computed(() => {
        if (props.to) {
            return { to: props.to };
        }
        if (props.link) {
            return { target: props.target };
        }
        return { type: props.type };
    });

    return { currentBindings, tag };
};

export default useButton;
